// SearchResults.jsx
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Navbar from './NavBar';
import Pagination from '@mui/material/Pagination';
import {
    BlogsBox,
    BlogsCard,
    BlogsCardMedia,
    BlogsCardContent,
    BlogsTypographyTitle,
    BlogsTypographyContent,
    BlogsBoxHover,
    BlogsButton
} from '../styles/blogsStyled';
import { LatestBlogsTypographyButton } from '../styles/homeStyled';
import { Stack, Container } from '@mui/material';





const SearchResults = ({ posts }) => {

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    console.log(params);
    const query = params.get('query')?.toLowerCase() || '';

    const results = posts.filter(post =>
        post.title.toLowerCase().includes(query) ||
        post.content.toLowerCase().includes(query)
    );

    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 4;

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = results.slice(indexOfFirstPost, indexOfLastPost);
    const handleChangePage = (event, value) => {
        setCurrentPage(value);  // Update the current page
    };

    return (
        <div>
            <Navbar />
            <BlogsBox component='article'>
                <Container maxWidth="lg">
                    <Stack gap='50px' alignItems='center'>
                        <h2>Search results for: "{query}"</h2>
                        {/* Render only the posts for the current page */}
                        {currentPosts.map((post, index) => {
                            return (
                                <BlogsCard key={index}>
                                    <BlogsCardMedia
                                        component='div'
                                        sx={{ backgroundImage: `url(${post.featuredImage})` }}
                                        title={post.name}
                                        onMouseEnter={() => setHoveredIndex(index)}
                                        onMouseLeave={() => setHoveredIndex(null)}
                                    >
                                        {hoveredIndex === index && (
                                            <BlogsBoxHover>
                                                <Link
                                                    to={`/single/${post.slug}`}
                                                >
                                                    <BlogsButton
                                                        size="medium"
                                                        color="secondary"
                                                        variant="outlined"
                                                    >
                                                        <LatestBlogsTypographyButton>
                                                            Read More
                                                        </LatestBlogsTypographyButton>
                                                    </BlogsButton>
                                                </Link>
                                            </BlogsBoxHover>
                                        )}
                                    </BlogsCardMedia>
                                    <BlogsCardContent>
                                        <BlogsTypographyTitle color='secondary'>
                                            {post.title}
                                        </BlogsTypographyTitle>
                                        {/* I need to do this so it loads html from data. */}
                                        <BlogsTypographyContent dangerouslySetInnerHTML={{ __html: post.content }} />
                                    </BlogsCardContent>
                                </BlogsCard>
                            )
                        })}
                        {/* Pagination component */}
                        <Pagination
                            count={Math.ceil(results.length / postsPerPage)} // Total pages
                            page={currentPage}
                            onChange={handleChangePage}
                            color="secondary"
                        />
                    </Stack>
                </Container>
            </BlogsBox>
        </div>
    );
};

export default SearchResults;
